import React from "react";
import logo from "../../../Assets/logo-autocare.png";



const BizXAutoCare = () => {
  return (
    <img
    style={{ width: 20 }}
      src={logo}
      alt="logo" />
  );
};

export default BizXAutoCare;
